import { ArrayDataDisplay } from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkflowDatasetSubmissionTrigger.display.module.scss";

const cx = classNames.bind(styles);

export const renderDatasetSubmissionOverviewListValue = (
  items: string[]
): React.ReactNode => {
  if (items.length === 0) {
    return "-";
  }

  if (items.length === 1) {
    return items[0];
  }

  return (
    <ArrayDataDisplay
      alignment="right"
      value={items}
      className={cx("overviewArrayValue")}
    />
  );
};
